class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/sip-provision`;
    }
    /**
     * Creates SIP registration of a device/application (WebPhone, Mobile, Softphone).
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/client-info/sip-provision
     * Rate Limit Group: Heavy
     * App Permission: VoipCalling
     */
    async post(createSipRegistrationRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), createSipRegistrationRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
